export default "__VITE_ASSET__lFpJjaBS__"